var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRelay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1014 17.3647L19.3278 4.58971C19.4073 4.47964 19.5797 4.56549 19.5397 4.69526L16.9436 13.1328C16.8011 13.5958 17.1473 14.0645 17.6318 14.0645H21.3722C21.6659 14.0645 21.836 14.3972 21.664 14.6353L12.3595 27.5185C12.2829 27.6246 12.1159 27.5488 12.1453 27.4212L14.1308 18.8174C14.2349 18.3662 13.8923 17.9355 13.4292 17.9355H10.3932C10.0996 17.9355 9.92944 17.6028 10.1014 17.3647Z",
    fill: "url(#hinava_random_uuid_330469496369261491443763102125526498950)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 4C9.37258 4 4 9.37258 4 16C4 20.8483 6.87518 25.025 11.0135 26.9181L11.5946 24.5317C8.50894 22.9352 6.4 19.7139 6.4 16C6.4 10.6981 10.6981 6.4 16 6.4C16.2405 6.4 16.4789 6.40884 16.715 6.42622L18.4 4.24004C17.6245 4.08263 16.8219 4 16 4Z",
    fill: "url(#hinava_random_uuid_266134458094220351707070387967793328753)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2005 25.5672C15.4641 25.5889 15.7308 25.6 16 25.6C21.3019 25.6 25.6 21.3019 25.6 16C25.6 12.0887 23.2609 8.72367 19.9052 7.22758L20.5127 4.87741C24.9037 6.66072 28 10.9688 28 16C28 22.6274 22.6274 28 16 28C15.2087 28 14.4353 27.9234 13.6867 27.7772L15.2005 25.5672Z",
    fill: "url(#hinava_random_uuid_32864728024745033213023838276891887460)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_330469496369261491443763102125526498950",
    x1: 16,
    y1: 4,
    x2: 16,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_266134458094220351707070387967793328753",
    x1: 16,
    y1: 4,
    x2: 16,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_32864728024745033213023838276891887460",
    x1: 16,
    y1: 4,
    x2: 16,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelay);
export default __webpack_public_path__ + "static/media/relay.0c67cb79e23c522ff78a3fdf36210122.svg";
export { ForwardRef as ReactComponent };